import {memo, PropsWithChildren} from "react";

const SectionTitle = ({children}: PropsWithChildren) => {
  return (
    <h5 className="font-i font-medium	text-[13px] text-gray-600 ml-3 tracking-[3px]">{children}</h5>
  );
};

export default memo(SectionTitle);
